import { FiltersType } from '../../types/AppTypes';
import {
  SET_START_DATE,
  SET_END_DATE,
  SET_CHANNELS,
  SET_SUBCHANNELS,
  SET_FILTER_CHANNELS,
  SET_FILTER_SUBCHANNELS,
} from '../actionTypes';

interface InitialState {
  start: string;
  end: string;
  channels: string[];
  subchannels: string[];
  filters: FiltersType;
}

const initialState: InitialState = {
  start: new Date(new Date().setDate(new Date().getDate() - 7)).toString(),
  end: new Date().toString(),
  channels: [],
  subchannels: [],
  filters: {
    start: new Date(new Date().setDate(new Date().getDate() - 7)),
    end: new Date(),
    channels: [],
    subchannels: [],
  },
};

export default function filters(state = initialState, action: any) {
  switch (action.type) {
    case SET_START_DATE: {
      return {
        ...state,
        start: action.payload,
        filters: {
          ...state.filters,
          start: new Date(action.payload),
        },
      };
    }
    case SET_END_DATE: {
      return {
        ...state,
        end: action.payload,
        filters: {
          ...state.filters,
          end: new Date(action.payload),
        },
      };
    }
    case SET_CHANNELS: {
      return {
        ...state,
        channels: action.payload,
      };
    }
    case SET_SUBCHANNELS: {
      return {
        ...state,
        subchannels: action.payload,
      };
    }
    case SET_FILTER_CHANNELS: {
      return {
        ...state,
        filters: {
          ...state.filters,
          channels: action.payload,
        },
      };
    }
    case SET_FILTER_SUBCHANNELS: {
      return {
        ...state,
        filters: {
          ...state.filters,
          subchannels: action.payload,
        },
      };
    }
    default:
      return state;
  }
}
